
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Draft from "@/views-oms/asking-for-quotation-management/Draft.vue";
@Component({
  name: "editQuotation",
  components: {
    Draft,
  },
})
export default class extends Vue {}
